import * as Scrivito from 'scrivito';
import { TableCellWidgetClass } from './table-cell-widget-class';

export const TableCellWidgetComponent: React.FC<Scrivito.WidgetComponentProps> = () => {
  return <Scrivito.WidgetTag>content</Scrivito.WidgetTag>;
};

Scrivito.provideComponent(TableCellWidgetClass, TableCellWidgetComponent);
